import React, { useCallback } from 'react'
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native'
import { ShiftType } from '../../../navigator/types'
import { corporateColor, textColor } from '../../../theme/colors'

interface ShiftSelectorProps {
  selectedShift: ShiftType | null
  onSelectShift: (shift: ShiftType) => void
  totalCenters?: number
  hasJobsInAM?: boolean
  hasJobsInPM?: boolean
  hasJobsInCompleteShift?: boolean
}
const AM = 'AM'
const PM = 'PM'
const COMPLETE_SHIFT = 'Jornada Completa'
export const ShiftSelector = ({
  selectedShift,
  onSelectShift,
  totalCenters = 1,
  hasJobsInAM = false,
  hasJobsInPM = false,
  hasJobsInCompleteShift = false,
}: ShiftSelectorProps) => {
  const getShiftConfig: () => {
    options: ShiftType[]
    disabled: string[]
    defaultShift: string
  } = useCallback(() => {
    // Si hay múltiples centros, permitir AM y PM para todos
    if (totalCenters > 1) {
      return {
        options: [AM, PM],
        disabled: [],
        defaultShift: AM,
      }
    }

    // Lógica para un solo centro
    const disabledShifts: string[] = []

    // Si hay trabajos en JORNADA COMPLETA, deshabilitar AM y PM
    if (hasJobsInCompleteShift) {
      disabledShifts.push(AM, PM)
      return {
        options: [AM, PM, COMPLETE_SHIFT],
        disabled: disabledShifts,
        defaultShift: COMPLETE_SHIFT,
      }
    }

    // Si hay trabajos en AM o PM, deshabilitar JORNADA COMPLETA
    // AM y PM siempre quedan habilitados entre sí
    if (hasJobsInAM || hasJobsInPM) {
      disabledShifts.push(COMPLETE_SHIFT)
    }

    return {
      options: [AM, PM, COMPLETE_SHIFT],
      disabled: disabledShifts,
      defaultShift: AM,
    }
  }, [totalCenters, hasJobsInAM, hasJobsInPM, hasJobsInCompleteShift])
  return (
    <View style={styles.container}>
      <Text style={styles.label}>Seleccione una jornada de trabajo</Text>
      <View style={styles.buttonGroup}>
        {getShiftConfig().options.map((shift) => (
          <TouchableOpacity
            key={shift}
            style={[
              styles.button,
              getShiftConfig().disabled.includes(shift) && styles.disabled,
              selectedShift === shift && styles.buttonActive,
              totalCenters === 1 && shift === COMPLETE_SHIFT ? { flexBasis: '100%' } : { flex: 1 },
            ]}
            disabled={getShiftConfig().disabled.includes(shift)}
            onPress={() => onSelectShift(shift)}
          >
            <Text style={[styles.buttonText, selectedShift === shift && styles.buttonTextActive]}>
              {shift}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
  },
  label: {
    fontSize: 16,
    color: textColor,
    fontWeight: '500',
    marginBottom: 12,
  },
  buttonGroup: {
    flexDirection: 'row',
    gap: 12,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  button: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: corporateColor,
    backgroundColor: '#fff',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  buttonActive: {
    backgroundColor: corporateColor,
    borderColor: corporateColor,
  },
  buttonText: {
    fontSize: 14,
    fontWeight: '600',
    color: corporateColor,
  },
  buttonTextActive: {
    color: '#fff',
  },
})
